/** Document.type for PDFs created from sell sheet flows (matches backend sell_sheets_view). */
export const SELL_SHEET_DOCUMENT_TYPE = 8;
